module.exports = "/dist/images/hr.61fa5658.png";